import { render, staticRenderFns } from "./group-landing.vue?vue&type=template&id=a267d8d2&lang=pug"
import script from "./group-landing.vue?vue&type=script&lang=js"
export * from "./group-landing.vue?vue&type=script&lang=js"
import style0 from "./group-landing.vue?vue&type=style&index=0&id=a267d8d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/docker/code/frontend/components/Header.vue').default,Body: require('/home/docker/code/frontend/components/Body.vue').default,Footer: require('/home/docker/code/frontend/components/Footer.vue').default})
